export default __webpack_public_path__ + "static/media/Smalldots.60a12ac8.svg";